import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	label: string | null;
	value: string | null;
};

export const ChartTooltipRow: FC<Props> = ({ label, value }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			gap={theme.spacingTokens.xs}
		>
			<Typography variant="caption" color={theme.palette.grey[500]}>
				{label}
			</Typography>
			<Typography variant="button" color={theme.palette.grey[900]} tabular>
				{value}
			</Typography>
		</Stack>
	);
};
